import { render, staticRenderFns } from "./HyphenSelect.vue?vue&type=template&id=2a0defb6&scoped=true"
import script from "./HyphenSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenSelect.vue?vue&type=style&index=0&id=2a0defb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0defb6",
  null
  
)

export default component.exports